import { FC } from 'react';

type IconProps = { size?: number };

export const DoubleMediaIcon: FC<IconProps> = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="20" height="9" rx="1" fill="currentColor" />
            <rect x="2" y="13" width="20" height="9" rx="1" fill="currentColor" />
        </svg>
    );
};

export const FullMediaIcon: FC<IconProps> = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="9" height="9" rx="1" fill="currentColor" />
            <rect x="2" y="13" width="9" height="9" rx="1" fill="currentColor" />
            <rect x="13" y="2" width="9" height="9" rx="1" fill="currentColor" />
            <rect x="13" y="13" width="9" height="9" rx="1" fill="currentColor" />
        </svg>
    );
};

export const SingleMediaIcon: FC<IconProps> = ({ size = 24 }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="20" height="20" rx="1" fill="currentColor" />
        </svg>
    );
};
